import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const CONTINUOUS_DISTANCE_TYPE = 'P360_Distance';

export const normalizeContinuousDistance = (
    table,
    { startTimestamp, endTimestamp, zone }
) => {
    const start = Date.parse(startTimestamp);
    const end = Date.parse(endTimestamp);
    if (!Number.isFinite(start) || !Number.isFinite(end) || start >= end) return [];
    const firstDate = dayjs(start).tz(zone).format('YYYY-MM-DD');
    const endDate = dayjs(end).tz(zone).format('YYYY-MM-DD');
    const days = new Map();
    const columns = Array.isArray(table?.columns) ? table.columns : [];
    const timeIndex = columns.indexOf('ts');
    const distanceIndex = columns.indexOf('distance');
    for (const row of Array.isArray(table?.data) ? table.data : []) {
        if (
            timeIndex < 0 ||
            distanceIndex < 0 ||
            !Array.isArray(row) ||
            row.length !== columns.length
        )
            continue;
        const timestamp =
            typeof row[timeIndex] === 'string' ? Date.parse(row[timeIndex]) : NaN;
        const rawDistance = row[distanceIndex];
        if (
            !Number.isFinite(timestamp) ||
            !['number', 'string'].includes(typeof rawDistance) ||
            String(rawDistance).trim() === ''
        )
            continue;
        const distance = Number(rawDistance);
        if (!Number.isFinite(distance) || distance < 0) continue;
        // The sample represents a UTC calendar day, not the day of the upload.
        const date = dayjs.utc(timestamp).format('YYYY-MM-DD');
        if (date < firstDate || date >= endDate) continue;
        const revision = timestamp;
        if (!days.has(date) || revision >= days.get(date).revision) {
            days.set(date, { distance, revision });
        }
    }
    const data = [];
    for (
        let date = firstDate;
        date < endDate;
        date = dayjs.utc(date).add(1, 'day').format('YYYY-MM-DD')
    ) {
        data.push({ date, distance: days.get(date)?.distance ?? null });
    }
    return data;
};
